module.exports = __webpack_public_path__ + "img/ExhibitSpecialRight.8bdc8d70.png";